export default __webpack_public_path__ + "static/media/more-icon.cd20164d.svg";